import { api } from "@/lib/api";

let loading = null;
export function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve(true);
  if (loading) return loading;
  loading = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => { loading = null; resolve(false); };
    document.body.appendChild(s);
  });
  return loading;
}

/** Is online payment switched on (key id + secret present on the server)? */
export async function paymentsEnabled() {
  return (await paymentsStatus()).enabled;
}

/** { enabled, mode, reason }  reason: "outdated_server" | "key_id_missing" | "key_secret_missing" | "unreachable" | null */
export async function paymentsStatus() {
  try {
    const { data } = await api.get("/payments/config");
    return { enabled: !!data?.enabled, mode: data?.mode || null, reason: data?.enabled ? null : data?.reason || "key_id_missing" };
  } catch (e) {
    const st = e?.response?.status;
    return { enabled: false, mode: null, reason: st === 404 || st === 405 ? "outdated_server" : "unreachable" };
  }
}

/**
 * Open Razorpay Checkout for a plan. The price is always calculated by the server.
 * Resolves with { ok, ends_at } after the server has verified the signature.
 * Rejects with err.cancelled = true when the person closes the window.
 */
export async function payForPlan({ plan, months = 6, venue_id }) {
  const ok = await loadRazorpay();
  if (!ok) throw new Error("Couldn't load the Razorpay window. Check your internet connection and try again.");
  const { data } = await api.post("/subscriptions/checkout", { plan, months, venue_id });
  return new Promise((resolve, reject) => {
    const rz = new window.Razorpay({
      key: data.key_id,
      amount: data.amount,
      currency: data.currency,
      name: data.name,
      description: data.description,
      order_id: data.order_id,
      image: `${window.location.origin}/icons/icon-192.png`,
      prefill: data.prefill,
      theme: { color: "#8C1C22" },
      handler: async (resp) => {
        try { const v = await api.post("/subscriptions/verify", resp); resolve(v.data); }
        catch (e) { reject(e); }
      },
      modal: { ondismiss: () => reject(Object.assign(new Error("Payment cancelled"), { cancelled: true })) },
    });
    rz.on("payment.failed", (r) => reject(new Error(r?.error?.description || "Payment failed")));
    rz.open();
  });
}
